import styled from 'styled-components/macro';
import { IconAlertCircle } from '@podiumhq/icons';

import { useNotificationContext } from 'contexts/NotificationContextProvider';
import useShouldScrollToElement from '../../hooks/useShouldScrollToElement';

const Notification = ({ shouldScrollToError }) => {
  const { message, shouldDisplay } = useNotificationContext() || {};
  const scrollRef = useShouldScrollToElement(
    shouldScrollToError && shouldDisplay
  );

  return shouldDisplay ? (
    <NotificationWrapper ref={scrollRef}>
      <IconAlert />
      <span>{message}</span>
    </NotificationWrapper>
  ) : null;
};

const NotificationWrapper = styled.div`
  align-content: center;
  align-items: center;
  background-color: #fae4e5;
  border-radius: 16px;
  color: #db4f58;
  display: flex;
  fill: #db4f58;
  font-size: 17px;
  line-height: 150%;
  margin-bottom: 24px;
  padding: 11px;
`;

const IconAlert = styled(IconAlertCircle)`
  margin-right: 8px;
`;

export default Notification;
